const AboutMe = () => {
  return (
    <section >
      <h2 className="title-font pink-text h2-tag">About Me</h2>
      <p className="white-text p-tag">
      I am currently a junior student at Ho Chi Minh City University of Technology, 
      with a passion for programming. I have gained experience in languages such as C/C++ and Python. 
      I combine my management expertise with technical skills and fully commit to consistency, 
      meeting deadlines, and utilizing all available resources to achieve results. My effective use of time, 
      problem-solving abilities, and communication skills help me maintain a positive attitude in complex situations. 
      Additionally, my desire to learn quickly enables me to adapt to changing situations and
      I am always eager to expand my knowledge in the field of embedded systems.
      </p>
    </section>
  );
};
export default AboutMe;
